import { authorizedAPI } from "@/config/axios.config";
import { UtilsService } from "../utils";
import type {
  ListTriggerRunsParams,
  UpsertProcessTriggerInput,
} from "@/types/process-trigger.types";

const utils = new UtilsService();

class ProcessTriggerService {
  // Admin: trigger configuration
  getForProcess(processId: string) {
    return utils.handleApiRequest(() => authorizedAPI.get(`/processes/${processId}/triggers`));
  }

  create(processId: string, input: UpsertProcessTriggerInput) {
    return utils.handleApiRequest(() =>
      authorizedAPI.post(`/processes/${processId}/triggers`, input)
    );
  }

  update(id: string, input: UpsertProcessTriggerInput) {
    return utils.handleApiRequest(() => authorizedAPI.put(`/process-triggers/${id}`, input));
  }

  remove(id: string) {
    return utils.handleApiRequest(() => authorizedAPI.delete(`/process-triggers/${id}`));
  }

  // Pending starts
  getMine() {
    return utils.handleApiRequest(() => authorizedAPI.get("/trigger-runs/mine"));
  }

  getRun(id: string) {
    return utils.handleApiRequest(() => authorizedAPI.get(`/trigger-runs/${id}`));
  }

  getForApplication(applicantProcessId: string) {
    return utils.handleApiRequest(() =>
      authorizedAPI.get(`/trigger-runs/application/${applicantProcessId}`)
    );
  }

  list(params: ListTriggerRunsParams) {
    return utils.handleApiRequest(() => authorizedAPI.get("/trigger-runs", { params }));
  }

  decline(id: string, reason?: string) {
    return utils.handleApiRequest(() =>
      authorizedAPI.post(`/trigger-runs/${id}/decline`, { reason })
    );
  }

  cancel(id: string, reason?: string) {
    return utils.handleApiRequest(() =>
      authorizedAPI.post(`/trigger-runs/${id}/cancel`, { reason })
    );
  }

  resend(id: string) {
    return utils.handleApiRequest(() => authorizedAPI.post(`/trigger-runs/${id}/resend`));
  }
}

export const processTriggerService = new ProcessTriggerService();
